import { FunctionComponent } from "react";
import { useParams, useLocation } from "react-router-dom";
import { IonPage, IonSpinner, IonText } from "@ionic/react";
import { AllParams, ParamsNames } from "../../../../modules/router/constantes/paramsNames";
import { useUserContext } from "../../../../modules/user/contexts/user.context";
import { RouteBuilder } from "../../../../modules/router/constantes/routes.const";
import { PlanComponent } from "../../../../modules/plan/components/plan.component";
import { MappedAreaService } from "../../../../modules/plan/services/mapped-area.service";
import { AnnotationFloorService } from "../../../../modules/plan/services/annotation.service";
import { AttributeFloorService } from "../../../../modules/plan/services/attribute.service";
import { MetaLibraryService } from '../../../../modules/plan/services/meta-library.service';
import { useAnnotationsWithLibrary } from '../../../../modules/annotation/hooks';
import { useOrganizationCode } from "../../../../modules/router/hooks/use-organization-code.hook";
import { useLocale } from "../../../../modules/router/hooks/use-locale.hook";

export const FloorPage: FunctionComponent = () => {
  const params = useParams<Pick<AllParams, ParamsNames.SITE_ID | ParamsNames.BUILDING_ID | ParamsNames.FLOOR_ID | ParamsNames.ASSET_ID>>();
  const location = useLocation<{ address?: string }>();
  
  // Récupérer l'adresse depuis location.state ou sessionStorage (fallback pour Ionic)
  const buildingAddress = location.state?.address || sessionStorage.getItem('buildingAddress');

  const { hasUser, currentOrganization } = useUserContext();
  
  // Attendre que l'utilisateur et l'organisation soient chargés avant d'accéder au code organisation
  const codeOrganization = hasUser && currentOrganization ? currentOrganization.code : null;
  const { getFloorAnnotations } = useAnnotationsWithLibrary();
  const organizationCode = useOrganizationCode();
  const locale = useLocale();

  // Afficher un loader si l'organisation n'est pas encore chargée
  if (!hasUser || !currentOrganization || !codeOrganization) {
    return (
      <IonPage>
        <IonSpinner />
        <IonText>Chargement...</IonText>
      </IonPage>
    );
  }

  return (
    <PlanComponent
      planId={params.floorId}
      backRoute={RouteBuilder.building(params.siteId, params.buildingId, locale, organizationCode)}
      getAttributes={(assetId) => {
        return AttributeFloorService.getAttributes(codeOrganization, params.siteId, params.buildingId, params.floorId, assetId);
      }}
      updateAttribute={(componentId, attributeId, updateAttribute) =>
        AttributeFloorService.updateAttribute(codeOrganization, componentId, attributeId, {
          ...updateAttribute,
          siteId: params.siteId,
          buildingId: params.buildingId,
          floorId: params.floorId,
          componentId,
          id: attributeId
        })

      }
      getPlan={() => MappedAreaService.getFloorMappedArea(codeOrganization, params.floorId)}
      getAnnotation={() =>
        getFloorAnnotations(codeOrganization, params.siteId, params.buildingId, params.floorId)
      }
      createAnnotation={(annotation) =>
        AnnotationFloorService.createAnnotation(codeOrganization, {
          ...annotation,
          siteId: params.siteId,
          buildingId: params.buildingId,
          floorId: params.floorId
        })
      }
      updateAnnotation={(...args) =>
        AnnotationFloorService.updateAnnotation(
          codeOrganization,
          params.siteId,
          params.buildingId,
          params.floorId,
          ...args
        )
      }
      deleteAnnotation={(annotationId:string,annotationFileName:string | null) =>
        AnnotationFloorService.deleteAnnotation(codeOrganization, {
          id: annotationId,
          siteId: params.siteId,
          buildingId: params.buildingId,
          floorId: params.floorId,
          fileName:annotationFileName,
        })
      }
      getCharacteristics={(componentTypeCodes) => {
        return MetaLibraryService.getCharacteristics(codeOrganization, componentTypeCodes);
      }}
      buildingAddress={ buildingAddress || undefined }
    />
  );
};
